<template>
    <div class="input-container form-group">
      <select
        id="sortType"
        style="max-width: 100%; border: 1px solid #d2d6da; color: #495057; border-radius: 0.5rem; font-size: 0.85rem; padding: 0.5rem 0.75rem; margin-right: 10px;"
        v-model="localSortValue"
        @change="changeSortAction"
      >
        <option v-for="option in options" :key="option.key" :value="option.value">
          {{ option.text }}
        </option>
      </select>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SortTemplate',
    props: {
      options: {
        type: Array,
        required: true,
      },
      sortValue: {
        type: String,
        required: true,
      },
      changeSortAction: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        localSortValue: this.sortValue,
      };
    },
    watch: {
      sortValue(newValue) {
        this.localSortValue = newValue;
      },
      localSortValue(newValue) {
        this.$emit('input', newValue);
      },
    },
  };
  </script>
  